import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { KostDataImportNewDatasetInputResultErrorsComponent } from './errors';
import { Message } from 'primeng/message';

@Component({
  selector: 'kost-data-import-new-dataset-input-result',
  template: `
    @if (!data.output.errors || data.output.errors.length === 0) {
      <p-message severity="success" i18n>
        Datensatz erfolgreich eingelesen
      </p-message>
    } @else {
      <kost-data-import-new-dataset-input-result-errors
        [errors]="data.output.errors"
      >
      </kost-data-import-new-dataset-input-result-errors>
    }
  `,

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [KostDataImportNewDatasetInputResultErrorsComponent, Message],
})
export class KostDataImportNewDatasetInputResultComponent {
  @Input()
  public data: {
    input: File;
    output: {
      errors?: string[];
      transformed: unknown;
      additionalInformation: unknown;
      additionalArtifacts: { content: File | Blob; displayName: string }[];
    };
  };
}
